"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  SET_AUTH: null,
  FETCH_FOLDERS_ATTEMPTED: null,
  FETCH_FOLDERS_SUCCEEDED: null,
  FETCH_FOLDERS_FAILED: null,
  ADD_FOLDER_ATTEMPTED: null,
  ADD_FOLDER_SUCCEEDED: null,
  ADD_FOLDER_FAILED: null,
  DELETE_FOLDER_ATTEMPTED: null,
  DELETE_FOLDER_SUCCEEDED: null,
  DELETE_FOLDER_FAILED: null,
  MOVE_FOLDER_ATTEMPTED: null,
  MOVE_FOLDER_SUCCEEDED: null,
  MOVE_FOLDER_FAILED: null,
  RENAME_FOLDER_ATTEMPTED: null,
  RENAME_FOLDER_SUCCEEDED: null,
  RENAME_FOLDER_FAILED: null,
  BULK_DELETE_ATTEMPTED: null,
  BULK_DELETE_SUCCEEDED: null,
  BULK_DELETE_FAILED: null,
  BULK_MOVE_ATTEMPTED: null,
  BULK_MOVE_SUCCEEDED: null,
  BULK_MOVE_FAILED: null,
  FETCH_FILES_ATTEMPTED: null,
  FETCH_FILES_SUCCEEDED: null,
  FETCH_FILES_FAILED: null,
  FETCH_MORE_FILES_ATTEMPTED: null,
  FETCH_MORE_FILES_SUCCEEDED: null,
  FETCH_MORE_FILES_FAILED: null,
  UPLOAD_FILE_PROGRESS: null,
  UPLOAD_FILE_ATTEMPTED: null,
  UPLOAD_FILE_SUCCEEDED: null,
  UPLOAD_FILE_FAILED: null,
  BULK_UPLOAD_FILES_ATTEMPTED: null,
  REPLACE_FILE_PROGRESS: null,
  REPLACE_FILE_ATTEMPTED: null,
  REPLACE_FILE_SUCCEEDED: null,
  REPLACE_FILE_FAILED: null,
  SAVE_EDIT_ATTEMPTED: null,
  SAVE_EDIT_SUCCEEDED: null,
  SAVE_EDIT_FAILED: null,
  DELETE_FILE_ATTEMPTED: null,
  DELETE_FILE_SUCCEEDED: null,
  DELETE_FILE_FAILED: null,
  ARCHIVE_FILE_ATTEMPTED: null,
  ARCHIVE_FILE_SUCCEEDED: null,
  ARCHIVE_FILE_FAILED: null,
  UNARCHIVE_FILE_ATTEMPTED: null,
  UNARCHIVE_FILE_SUCCEEDED: null,
  UNARCHIVE_FILE_FAILED: null,
  MOVE_FILE_ATTEMPTED: null,
  MOVE_FILE_SUCCEEDED: null,
  MOVE_FILE_FAILED: null,
  RENAME_FILE_ATTEMPTED: null,
  RENAME_FILE_SUCCEEDED: null,
  RENAME_FILE_FAILED: null,
  FETCH_USER_SETTINGS_SUCCEEDED: null,
  FETCH_USER_SETTINGS_EMPTY: null,
  FETCH_USER_SETTINGS_FAILED: null,
  SAVE_USER_SETTINGS_ATTEMPTED: null,
  SAVE_USER_SETTINGS_SUCCEEDED: null,
  SAVE_USER_SETTINGS_FAILED: null,
  UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED: null,
  UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED: null,
  UPDATE_VIDYARD_TOS_STATUS_FAILED: null,
  FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED: null,
  INFERRED_USER_ROLE_FETCH_SUCCEEDED: null,
  CREATE_VIDYARD_PLAYERID_ATTEMPTED: null,
  CREATE_VIDYARD_PLAYERID_SUCCEEDED: null,
  CREATE_VIDYARD_PLAYERID_FAILED: null,
  SOFT_DELETE_VIDYARD_PLAYERID_FAILED: null,
  SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED: null,
  CANVA_INIT_ATTEMPTED: null,
  CANVA_INIT_SUCCEEDED: null,
  CANVA_INIT_FAILED: null,
  DOWNLOAD_FROM_CANVA_ATTEMPTED: null,
  DOWNLOAD_FROM_CANVA_SUCCEEDED: null,
  DOWNLOAD_FROM_CANVA_FAILED: null,
  DOWNLOAD_FROM_DROPBOX_ATTEMPTED: null,
  DOWNLOAD_FROM_DROPBOX_SUCCEEDED: null,
  DOWNLOAD_FROM_DROPBOX_FAILED: null,
  DOWNLOAD_FROM_DRIVE_ATTEMPTED: null,
  DOWNLOAD_FROM_DRIVE_SUCCEEDED: null,
  DOWNLOAD_FROM_DRIVE_FAILED: null,
  VIDEO_THUMBNAIL_UPDATE_ATTEMPTED: null,
  VIDEO_THUMBNAIL_UPDATE_FAILED: null,
  VIDEO_THUMBNAIL_UPDATE_SUCCEEDED: null,
  GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED: null,
  GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED: null,
  GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED: null,
  FETCH_LIMITS_SUCCEEDED: null,
  CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED: null,
  DECREASE_VIDEO_QUANTITY_USED: null,
  SELECT_FILE: null,
  IMAGE_TO_EDIT_SELECTED: null,
  IMAGE_TO_EDIT_DESELECTED: null,
  UPLOAD_EDITED_IMAGE_ATTEMPTED: null,
  UPLOAD_EDITED_IMAGE_FAILED: null,
  UPLOAD_EDITED_IMAGE_SUCCEEDED: null,
  HUB_USERS_FETCH_SUCCEEDED: null,
  HUB_USERS_FETCH_FAILED: null,
  FETCH_SIGNED_URL_FAILED: null,
  SEARCH_SHUTTERSTOCK_RESET: null,
  SEARCH_SHUTTERSTOCK_ATTEMPTED: null,
  SEARCH_SHUTTERSTOCK_SUCCEEDED: null,
  SEARCH_SHUTTERSTOCK_FAILED: null,
  ACQUIRE_IMAGE_ATTEMPTED: null,
  ACQUIRE_IMAGE_SUCCEEDED: null,
  ACQUIRE_IMAGE_FAILED: null,
  RESET_PAGE: null,
  CHANGE_TAB: null
});

exports.default = _default;
module.exports = exports.default;